import { capitalizeLocationName, setReplaceText } from 'src/utils';

import { TextLink } from '@ads-core/components';
import { ChevronRightIcon } from '@ads-core/icons';
import { useRouter } from 'next/router';
import { useMedia } from 'react-use';
import { mq } from '@ads-core/breakpoints';
import { FilteredOutagesOnLocationProps } from 'components/OutagesOnLocation';
import { useParams } from 'src/hooks/useParams';
import { encodeBaseUrl } from 'src/utils/urlFormat/encodeBaseUrl';

export const RecentResolvedLinks = ({
  linkOne,
  linkTwo,
}: Pick<FilteredOutagesOnLocationProps, 'linkOne' | 'linkTwo'>) => {
  const { city } = useParams();
  const isDesktop = useMedia(mq.md);
  const router = useRouter();
  const path = router.query.path || [];
  const queryLocation = city || path[path.length - 1] || null;
  const location = capitalizeLocationName(queryLocation ?? '');

  const recentResolvedDesktopIcon = isDesktop ? <ChevronRightIcon size="sm" /> : undefined;
  const recentResolvedMobileIcon = !isDesktop ? <ChevronRightIcon size="sm" /> : undefined;

  return (
    <>
      {linkOne?.href && linkOne?.text && (
        <TextLink
          href={encodeBaseUrl(setReplaceText(linkOne.href, { '{places}': location }))}
          afterIcon={recentResolvedDesktopIcon}
          beforeIcon={recentResolvedMobileIcon}
        >
          {setReplaceText(linkOne.text, { '{places}': location })}
        </TextLink>
      )}
      {linkTwo?.href && linkTwo?.text && (
        <TextLink
          href={encodeBaseUrl(setReplaceText(linkTwo.href, { '{places}': location }))}
          afterIcon={recentResolvedDesktopIcon}
          beforeIcon={recentResolvedMobileIcon}
        >
          {setReplaceText(linkTwo.text, { '{places}': location })}
        </TextLink>
      )}
    </>
  );
};
